import React from 'react';
import SchemaBuilder from './SchemaBuilder';

function App() {
  return (
    <div className="App">
      <SchemaBuilder />
    </div>
  );
}

export default App;
